import React from "react";
import { Check } from "lucide-react";

import { CANAIS, temaDoCanal } from "@/components/canais/canais";
import IconeCanal from "@/components/canais/IconeCanal";

// Caixas de marcar dos módulos (decisão do dono, 21/09/2026): o lojista marca
// a quais módulos a despesa pertence. Um marcado = a despesa inteira vai para
// ele; vários = o valor é dividido em partes iguais; nenhum = despesa comum,
// sem módulo, que não entra no lucro de nenhum módulo no Relatório de Módulos.
export default function SeletorModulos({ valor, onChange }) {
  const alternar = (key) => onChange(valor.includes(key) ? valor.filter((k) => k !== key) : [...valor, key]);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2" data-e2e="seletor-modulos">
      {CANAIS.map((c) => {
        const marcado = valor.includes(c.key);
        return (
          <button key={c.key} type="button" role="checkbox" aria-checked={marcado} onClick={() => alternar(c.key)}
            data-e2e={`modulo-${c.key}`}
            className={`flex items-center gap-2 rounded-lg border px-2.5 py-2 text-left text-sm transition ${marcado
              ? "border-primary bg-primary/5 ring-1 ring-primary/40 font-semibold" : "hover:bg-muted/50"}`}>
            <span className={`w-4 h-4 rounded border flex items-center justify-center shrink-0 ${marcado ? "bg-primary border-primary text-primary-foreground" : "border-muted-foreground/40"}`}>
              {marcado && <Check className="w-3 h-3" />}
            </span>
            <span className={`w-6 h-6 rounded-md flex items-center justify-center shrink-0 ${temaDoCanal(c).icone}`}><IconeCanal canal={c} className="w-4 h-4" /></span>
            <span className="truncate">{c.nome}</span>
          </button>
        );
      })}
    </div>
  );
}
